import { Link } from 'gatsby';
import "../../../../src/pages/design/design-guidelines-styles.css";
import { DocsHeading } from "../../../../src/components/DocsHeading";
import * as React from 'react';
export default {
  Link,
  DocsHeading,
  React
};